import { SuiteManifest } from '../manifest';
import { supportRoutes } from './routes';
import { supportNavItems } from './nav';

export const supportManifest: SuiteManifest = {
  id: 'support',
  name: 'Support & Helpdesk',
  basePath: '/support',
  icon: 'bell',
  description: 'Support & Helpdesk suite modules and operations.',
  requiredPermission: 'support.read',
  nav: supportNavItems,
  routes: supportRoutes,
};

export default supportManifest;
